import { render, staticRenderFns } from "./AddCommodity.vue?vue&type=template&id=270db6fc"
import script from "./AddCommodity.vue?vue&type=script&lang=js"
export * from "./AddCommodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports